export default {
  included: 'app.report.include.traffic.button',
  excluded: 'app.report.exclude.traffic.button',
};
